import { Link } from "react-router-dom";
import { Phone, Mail, Globe } from "lucide-react";
import { PHONE, PHONE_TEL, EMAIL } from "@/data/content";

const FOOTER_LINKS = [
  { label: "Thermische branddetectie", to: "/hoe-het-werkt" },
  { label: "Toepassingen", to: "/toepassingen" },
  { label: "Werkwijze", to: "/werkwijze" },
  { label: "Offerte aanvragen", to: "/offerte" },
  { label: "Contact", to: "/contact" },
  { label: "Privacyverklaring", to: "/privacyverklaring" },
  { label: "Cookieverklaring", to: "/cookieverklaring" },
];

export const Footer = () => (
  <footer className="border-t border-white/5 bg-[#070a0d] pb-28 pt-16 lg:pb-16" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl gap-12 px-4 sm:px-6 md:grid-cols-3 lg:px-10">
      <div>
        <p className="font-heading text-lg font-bold uppercase tracking-[0.12em] text-[#F5F7F9]">
          Brandpreventie <span className="text-[#62C3F0]">Recycling</span>
        </p>
        <p className="mt-2 text-sm text-[#CBD3D9]/80">
          Een gespecialiseerde oplossing van Beveilig Alles B.V.
        </p>
        <p className="mt-6 max-w-xs text-xs leading-relaxed text-[#CBD3D9]/60">
          Product functies en detectiemogelijkheden verschillen per cameramodel en configuratie. Een
          projectgerichte beoordeling is noodzakelijk.
        </p>
      </div>
      <nav aria-label="Footer navigatie">
        <p className="mb-4 font-heading text-xs font-semibold uppercase tracking-[0.25em] text-[#62C3F0]">
          Navigatie
        </p>
        <ul className="grid gap-2.5">
          {FOOTER_LINKS.map((link) => (
            <li key={link.label}>
              <Link
                to={link.to}
                className="text-sm text-[#CBD3D9] transition-colors duration-300 hover:text-[#62C3F0]"
              >
                {link.label}
              </Link>
            </li>
          ))}
          <li>
            <a
              href="https://www.beveiligalles.nl"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-[#CBD3D9] transition-colors duration-300 hover:text-[#62C3F0]"
              data-testid="footer-beveiligalles-link"
            >
              Website Beveilig Alles B.V.
            </a>
          </li>
        </ul>
      </nav>
      <div>
        <p className="mb-4 font-heading text-xs font-semibold uppercase tracking-[0.25em] text-[#62C3F0]">
          Contact
        </p>
        <ul className="grid gap-3 text-sm text-[#CBD3D9]">
          <li>
            <a href={PHONE_TEL} className="flex items-center gap-2.5 transition-colors hover:text-[#62C3F0]" data-testid="footer-phone-link">
              <Phone size={15} className="text-[#2B9FD7]" /> {PHONE}
            </a>
          </li>
          <li>
            <a href={`mailto:${EMAIL}`} className="flex items-center gap-2.5 transition-colors hover:text-[#62C3F0]" data-testid="footer-email-link">
              <Mail size={15} className="text-[#2B9FD7]" /> {EMAIL}
            </a>
          </li>
          <li>
            <a href="https://www.beveiligalles.nl" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2.5 transition-colors hover:text-[#62C3F0]">
              <Globe size={15} className="text-[#2B9FD7]" /> www.beveiligalles.nl
            </a>
          </li>
        </ul>
        <button
          type="button"
          onClick={() => window.dispatchEvent(new CustomEvent("bpr-open-cookie-settings"))}
          className="mt-6 text-xs text-[#CBD3D9]/60 underline underline-offset-4 transition-colors hover:text-[#62C3F0]"
          data-testid="footer-cookie-settings"
        >
          Cookievoorkeuren aanpassen
        </button>
      </div>
    </div>
    <div className="mx-auto mt-12 max-w-7xl border-t border-white/5 px-4 pt-6 sm:px-6 lg:px-10">
      <p className="text-xs text-[#CBD3D9]/50">
        © {new Date().getFullYear()} Beveilig Alles B.V. Alle rechten voorbehouden.
      </p>
    </div>
  </footer>
);
